import axios from "axios";
import { useContext, useEffect } from "react";
import { completeUser, TOKEN_KEY, useAuthStore } from "../../authProvider";
import { setAuthToken } from "../../api";
import { ColorModeContext } from "../../contexts/color-mode";

export default function AuthCheck({ children }: { children: React.ReactNode }) {
  const { mode, setMode } = useContext(ColorModeContext);

  if (mode === "dark") {
    setMode();
  }

  const { setUser, check, setCheck } = useAuthStore();

  useEffect(() => {
    const authCheck = async () => {
      const token = localStorage.getItem(TOKEN_KEY);

      try {
        const res = await axios.get("/auth/current-user", {
          baseURL: import.meta.env.VITE_API_URL,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const user = res.data?.data;

        if (user) {
          setUser(completeUser(user));
          setCheck(true);
          setAuthToken();
        } else {
          throw new Error("Invalid token");
        }
      } catch (e) {
        setUser(undefined);
        setCheck(true);
      }
    };

    if (!check) {
      authCheck();
    }
  }, [check, setCheck, setUser]);

  if (check) {
    return children;
  }

  return <></>;
}
